export {default} from "./SmallGlowingCard";
